/* global recipe_label, simplified_hash, optional_vitamins, optional_vitamins_2, aggregate_vitamins */

import jQuery from "jquery";
import { saveLabel } from "./persistence.js";
import { withSectionExpanded } from "./util.js";
import { isFormat, isAdult, onFormat, isFDA, isCanadian } from "./format.js";
import { refreshSlider } from "./sliders.js";
import { showLanguages } from "./language.js";
import { tabularVitaminShuffle } from "./layout.js";
import { triggerSliders } from "./sliders.js";
import { simplifiedCheckboxForFormat } from "./simplified.js";
import { toggleOverrideInput } from "./overrides.js";

const $ = jQuery;

const toggleAllCheckbox = () => jQuery("#allvitaminstoggle");

const vitaminCheckboxes = () => {
  return jQuery("#optionalvitaminsdiv [data-toggles] input[type=checkbox]");
};

/* returns true if all optional vitamin checkboxes are checked */
const allToggled = () => {
  /* Make the :visible selector consistent regardless if the section is expanded or not. */
  return withSectionExpanded("#optionalvitaminsdiv", () => {
    const group = vitaminCheckboxes().filter(":visible");
    return group.length === group.filter(":checked").length;
  });
};

/* Returns a RecipeLabel attribute name for a checkbox */
const keyForCheckbox = (checkbox) => {
  const r = checkbox.closest("[data-toggles]").data("toggles");
  console.assert(r);

  return `show_${r}`;
};

/* returns a { show_vitamin_x: true, show_vitamin_y: false } Object suitable for persisting */
export const getVitaminToggles = () => {
  let result = {};
  vitaminCheckboxes().each((_, checkbox) => {
    const target = jQuery(checkbox);
    result[keyForCheckbox(target)] = target.prop("checked");
  });

  return result;
};

/* Updates checkboxes according to recipe_label */
export const updateVitaminToggles = ({ rebuildFunction }) => {
  vitaminCheckboxes().each((_, checkbox) => {
    const target = jQuery(checkbox);
    target.prop("checked", recipe_label[keyForCheckbox(target)]);
  });

  toggleAllCheckbox().prop("checked", allToggled());
  rebuildFunction();
};

export const applyCompactVitamins = (compact) => {
  // Only ever applied on single column vitamins
  document
    .querySelector("#newnutritionfactstable #newverticalvitaminsection")
    ?.classList.toggle("compact", compact);
};

/* installs event handlers and initial checkbox state */
export const initializeVitaminToggles = ({ rebuildFunction }) => {
  toggleAllCheckbox().on("click", () => {
    const allChecked = toggleAllCheckbox().prop("checked");
    vitaminCheckboxes().prop("checked", allChecked);
    rebuildFunction();

    saveLabel(getVitaminToggles());
  });

  vitaminCheckboxes().on("click", (ev) => {
    const target = jQuery(ev.target);
    toggleAllCheckbox().prop("checked", allToggled());

    rebuildFunction();
    saveLabel({
      [keyForCheckbox(target)]: target.is(":checked"),
    });
  });

  // Compact vitamin display
  $("#compact-vitamins").on("click", (event) => {
    const checked = event.target.checked;
    applyCompactVitamins(checked);
    saveLabel({ compact_vitamins: checked });
    rebuildFunction();
  });

  updateVitaminToggles({ rebuildFunction });
};

// set global variable
let totalvitamins = 0;

function visibleWithToggle(hashID, defaultVisible) {
  const toggle = $(`input.nutrientvisibilitytoggle[data-nutrient="${hashID}"]`);
  if (!toggle.length) return defaultVisible;

  if (simplifiedCheckboxForFormat()?.is(":checked")) return toggle.is(":checked");
  return toggle.is(":checked") ? false : defaultVisible;
}

// ABSTRACTION TIME - REGULAR LABEL - REBUILD EACH OPTIONAL VITAMIN, AS CALLED
function optionalVitaminTogglesRebuild(
  toggleBoolean,
  vitaminID,
  vitaminDisplay,
  hashID,
  container = null
) {
  // Ensure that visible vitamins can be overridden, and invisible ones cannot
  toggleOverrideInput(hashID, toggleBoolean);

  if (isFormat("legacy_fda/adult/vertical")) {
    if (toggleBoolean) {
      // check how many so far (even or odd)
      // if even, "leftvitamin", if odd "rightvitamin"
      // increment count
      if (totalvitamins % 2 == 0) {
        $(
          '<div class="vitamin"><div class="vitaminleft" id=' +
            vitaminID +
            ">" +
            vitaminDisplay +
            " " +
            optional_vitamins[hashID] +
            '%</div><br style="clear:both"></div><div class="hairlineseparator"></div>'
        ).appendTo("#vitaminsection");
      } else {
        $(
          '<div class="vitaminbullet">&#8226;</div><div class="vitaminright" id=' +
            vitaminID +
            ">" +
            vitaminDisplay +
            " " +
            optional_vitamins[hashID] +
            "%</div>"
        ).insertAfter(".vitaminleft:last");
      }
      totalvitamins++;
    }
  } else if (isFormat("fda/adult/vertical") && toggleBoolean) {
    const vitaminAbbreviations = {
      "Vitamin D": "Vit. D",
      "Potassium": "Potas.",
      "Vitamin A": "Vit. A",
      "Vitamin C": "Vit. C",
      "Vitamin E": "Vit. E",
      "Vitamin K": "Vit. K",
      "Vitamin B6": "Vit. B6",
      "Vitamin B12": "Vit. B12",
    };

    const compact = $("#compact-vitamins").is(":checked");

    if ($("#newnutritionfactstable").length > 0) {
      // Thick separator to start the section
      if (totalvitamins == 0) {
        $('<div class="thickseparator"></div>').appendTo("#newverticalvitaminsection");
      }

      // Thin separators between every vitamin normally, and every set of 2 when abbreviated
      if (totalvitamins > 0 && (!compact || (compact && totalvitamins % 2 === 0))) {
        $('<div class="hairlineseparator"></div>').appendTo("#newverticalvitaminsection");
      }

      // Individual nutrients
      if (compact) {
        $(
          `<span class="nutrientcontent">${
            vitaminAbbreviations[vitaminDisplay] || vitaminDisplay
          } ${optional_vitamins[hashID][1]}${optional_vitamins[hashID][0]} ${
            optional_vitamins[hashID][2]
          }%</span>`
        ).appendTo("#newverticalvitaminsection");
      } else {
        $(
          '<div class="new-vertical-row"><div class="pull-left"><div class="nutrientcontent">' +
            vitaminDisplay +
            " " +
            optional_vitamins[hashID][1] +
            optional_vitamins[hashID][0] +
            '</div></div><div class="pull-right"><div class="nutrientcontent">' +
            optional_vitamins[hashID][2] +
            '%</div></div><div class="clearfix"></div></div>'
        ).appendTo("#newverticalvitaminsection");
      }

      totalvitamins++;
    } else {
      // dual column for 2-3 servings label
      if (totalvitamins == 0) {
        $(
          '<div class="dual-left-col"><div class="thickseparator"></div></div><div class="dual-package-col"><div class="thickseparator"></div></div><div class="dual-serving-col"><div class="thickseparator"></div></div><div class="clearfix"></div>'
        ).appendTo("#newverticalvitaminsection");
      }
      if (totalvitamins > 0) {
        $(
          '<div class="dual-left-col"><div class="hairlineseparator"></div><div class="nutrientcontent">' +
            vitaminDisplay +
            '</div></div><div class="dual-package-col"><div class="hairlineseparator"></div><div class="pull-left"><div class="nutrient"><span class="nutrientcontent">' +
            optional_vitamins_2[hashID][1] +
            optional_vitamins_2[hashID][0] +
            '</span></div></div><div class="pull-right"><div class="nutrientcontent">' +
            optional_vitamins_2[hashID][2] +
            '%</div></div></div><div class="dual-serving-col"><div class="hairlineseparator"></div><div class="pull-left"><div class="nutrient"><span class="nutrientcontent">' +
            optional_vitamins[hashID][1] +
            optional_vitamins[hashID][0] +
            '</span></div></div><div class="pull-right"><div class="nutrientcontent">' +
            optional_vitamins[hashID][2] +
            '%</div></div></div><div class="clearfix"></div>'
        ).appendTo("#newverticalvitaminsection");
      } else {
        // no hairline separator
        $(
          '<div class="dual-left-col"><div class="nutrientcontent">' +
            vitaminDisplay +
            '</div></div><div class="dual-package-col"><div class="pull-left"><div class="nutrient"><span class="nutrientcontent">' +
            optional_vitamins_2[hashID][1] +
            optional_vitamins_2[hashID][0] +
            '</span></div></div><div class="pull-right"><div class="nutrientcontent">' +
            optional_vitamins_2[hashID][2] +
            '%</div></div></div><div class="dual-serving-col"><div class="pull-left"><div class="nutrient"><span class="nutrientcontent">' +
            optional_vitamins[hashID][1] +
            optional_vitamins[hashID][0] +
            '</span></div></div><div class="pull-right"><div class="nutrientcontent">' +
            optional_vitamins[hashID][2] +
            '%</div></div></div><div class="clearfix"></div>'
        ).appendTo("#newverticalvitaminsection");
      }
      totalvitamins++;
    }
  } else if (isFormat("canada/adult/vertical")) {
    if (toggleBoolean) {
      if (totalvitamins > 0) {
        $('<div class="hairlineseparator"></div>').appendTo("#newcanadavitaminsection");
      } else {
        $('<div class="canadathickseparator"></div>').appendTo("#newcanadavitaminsection");
      }

      let vitaminDisplayHTML;

      if (vitaminDisplay.split("/").length > 1) {
        vitaminDisplayHTML =
          '<span class="bilingual"><span class="bilingual-english">' +
          vitaminDisplay.split("/")[0] +
          '</span><span class="bilingual-separator"> / </span><span class="bilingual-french">' +
          vitaminDisplay.split("/")[1] +
          "</span></span>";
      } else {
        vitaminDisplayHTML = vitaminDisplay;
      }
      $(
        '<div class="pull-left"><div class="nutrientcontent" id=' +
          vitaminID +
          ">" +
          vitaminDisplayHTML +
          " " +
          optional_vitamins[hashID][1] +
          "&nbsp;" +
          optional_vitamins[hashID][0] +
          '</div></div><div class="pull-right"><div class="nutrientcontent">' +
          optional_vitamins[hashID][2] +
          '&nbsp;%</div></div><div class="clearfix"></div>'
      ).appendTo("#newcanadavitaminsection");
      totalvitamins++;
    }
  } else if (isFormat("canada/adult/tabular")) {
    if (toggleBoolean) {
      const isSimplified = simplifiedCheckboxForFormat().is(":checked");

      let container = null;
      let breakHeight = 0;
      if (isSimplified) {
        const nutrientColumnSet = $(
          ".CaTabularNFP-NutrientCols.CaTabularNFP-NutrientCols--simplified"
        ).first();
        container = nutrientColumnSet.find(".CaTabularNFP-NutrientCol").first();
      } else {
        const nutrientColumnSet = $(
          ".CaTabularNFP-NutrientCols:not(.CaTabularNFP-NutrientCols--simplified)"
        ).first();
        breakHeight = nutrientColumnSet.find(".CaTabularNFP-NutrientCol").first().height() - 4;
        container = nutrientColumnSet.find(".CaTabularNFP-NutrientCol").last();
      }

      if (isSimplified && totalvitamins == 0) {
        container.append(
          $(`
            <div class="CaTabularNFP-NutrientCol CaTabularNFP-NutrientCol--optional">
              <div class="CaTabularNFP-Separator CaTabularNFP-Separator--thick"></div>
            </div>
          `)
        );
      }

      if (!isSimplified && container.height() > breakHeight) {
        const separatorColumnSet = $(
          ".CaTabularNFP-NutrientCols:not(.CaTabularNFP-NutrientCols--simplified)"
        ).last();

        container = $(`
            <div class="CaTabularNFP-NutrientCol CaTabularNFP-NutrientCol--optional">
              <div class="CaTabularNFP-DVHeader bilingual">
                <span class="bilingual-english">
                  % DV
                  <span class="CaTabularNFP-DVHeader--asterisk">*</span>
                </span>
                <span class="bilingual-separator">/</span>
                <span class="bilingual-french">
                  % VQ
                  <span class="CaTabularNFP-DVHeader--asterisk">*</span>
                </span>
              </div>
              <div class="CaTabularNFP-Separator"></div>
            </div>
          `).insertAfter(container);
        separatorColumnSet.append(
          $(`
            <div class="CaTabularNFP-NutrientCol CaTabularNFP-NutrientCol--optional">
              <div class="CaTabularNFP-Separator CaTabularNFP-Separator--thick"></div>
            </div>
          `)
        );
      }

      const [measurement, value, percent] = optional_vitamins[hashID];
      if (vitaminDisplay.split("/").length > 1) {
        const [english, french] = vitaminDisplay.split("/");
        $(`
            <div class="CaTabularNFP-Nutrient CaTabularNFP-Nutrient--optional CaTabularNFP-Nutrient--standalone">
              <span class="bilingual">
                <span class="bilingual-english">${english}</span>
                <span class="bilingual-separator"> / </span>
                <span class="bilingual-french">${french}</span>
              </span>
              <span>
                ${value} ${measurement}
              </span>
              <div class="CaTabularNFP-Nutrient-Value">
                ${percent} %
              </div>
            </div>
          `).appendTo(container);
      } else {
        $(`
            <div class="CaTabularNFP-Nutrient CaTabularNFP-Nutrient--optional">
              <span>
                ${vitaminDisplay}
              </span>
              <span>
                ${value} ${measurement}
              </span>
              <div class="CaTabularNFP-Nutrient-Value">
                ${percent} %
              </div>
            </div>
          `).appendTo(container);
      }

      totalvitamins++;
    }
  } else if (
    isFormat("canada/adult/vertical/as_prepared") &&
    toggleBoolean &&
    "optional_vitamins_2" in window
  ) {
    totalvitamins++;
    const [measurement, value, percent] = optional_vitamins[hashID];
    const asPreparedPercent = optional_vitamins_2[hashID][2];
    const [englishName, frenchName] = vitaminDisplay.split(" / ");

    let vitaminDisplayHTML;
    if (!frenchName) {
      vitaminDisplayHTML = englishName;
    } else {
      vitaminDisplayHTML = `<span class="bilingual">
          <span class="bilingual-english">${englishName}</span>
          <span class="bilingual-separator">/</span>
          <span class="bilingual-french">${frenchName}</span>
        </span>`;
    }

    $(`<div>
        <div class="CaDualFormatNFP-LeftCol nutrientcontent">
          ${vitaminDisplayHTML}&nbsp;${value}&nbsp;${measurement}
        </div>
        <div class="CaDualFormatNFP-DualFormatCol nutrientcontent">${percent}&nbsp;%</div>
        <div class="CaDualFormatNFP-DualFormatCol nutrientcontent">${asPreparedPercent}&nbsp;%</div>
      </div>`).appendTo("#newcanadavitaminsection");
  } else if (isFormat("canada/adult/vertical/aggregate") && toggleBoolean) {
    totalvitamins++;
    let vitaminHtml;

    // Left column vitamin label
    const [englishName, frenchName] = vitaminDisplay.split(" / ");
    let vitaminLabel;
    if (!frenchName) {
      vitaminLabel = `<div>${englishName}</div>`;
    } else {
      vitaminLabel = `<div class="bilingual">
        <span class="bilingual-english">${englishName}</span>
        <span class="bilingual-separator">/</span>
        <span class="bilingual-french">${frenchName}</span>
      </div>`;
    }

    vitaminHtml = `<div class="CaAggregate-LeftCol nutrientcontent">${vitaminLabel}</div>`;

    // Recipe columns vitamin values
    Array.from(aggregate_vitamins)
      .reverse()
      .forEach((vitamins, index) => {
        const [measurement, value, percent] = vitamins[hashID];

        const vitaminValueDisplay = `<div class="ca-aggregate-nutrient-row">
        <span>${value}&nbsp;${measurement}</span>
        <span>${percent}&nbsp;%</span>
      </div>`;

        let firstRowClass;
        if (totalvitamins === 1) {
          firstRowClass = "first-vitamin-row";
        }

        vitaminHtml += `<div class="CaAggregate-RecipeCol ${firstRowClass}">${vitaminValueDisplay}</div>`;
      });

    vitaminHtml += `<div class="clearfix"></div>`;
    document
      .querySelector("#ca-aggregate-vitamin-section")
      .insertAdjacentHTML("beforeend", vitaminHtml);
  } else if (
    isFormat("legacy_fda/adult/vertical/as_prepared") &&
    toggleBoolean &&
    "optional_vitamins_2" in window
  ) {
    $(
      '<div class="dual-left-col"><div class="vitamin">' +
        vitaminDisplay +
        '</div></div><div class="dual-prepared-col"><div class="vitamin">' +
        optional_vitamins_2[hashID] +
        '%</div></div><div class="dual-packaged-col"><div class="vitamin">' +
        optional_vitamins[hashID] +
        '%</div></div><div class="clearfix"></div><div class="hairlineseparator"></div>'
    ).appendTo("#aggregate-vitaminsection");
    totalvitamins++;
  } else if (isFormat("canada/adult/linear")) {
    if (toggleBoolean) {
      // add comma back in if we removed it from last non vitamin nutrient
      if (totalvitamins == 0) {
        const last_nutrient = $(container.end)
          .parent()
          .prevAll("div:visible")
          .first()
          .children()
          .last();

        if (last_nutrient.length > 0 && last_nutrient.html().split(",").length < 2) {
          last_nutrient.html(last_nutrient.html() + ",&#8197;");
        }
      }
      $(
        '<div class="linearvitamins" style="float:left;"><div class="linearnutrient linearcanada">' +
          vitaminDisplay +
          "&nbsp;" +
          '</div><div class="linearnutrientcontent linearcanada">' +
          optional_vitamins[hashID][1] +
          "&nbsp;" +
          optional_vitamins[hashID][0] +
          " (" +
          optional_vitamins[hashID][2] +
          " %),&nbsp;</div></div>"
      ).insertBefore(container.end);
      totalvitamins++;
    }
  } else if (isFormat("legacy_fda/infant/vertical")) {
    if (toggleBoolean) {
      if (totalvitamins % 2 == 0) {
        $(
          `<div class="hairlineseparator"></div><div class="infantvitamin" data-test-id="vitamin-${vitaminID}"><div class="infantvitaminleft">${vitaminDisplay} <span>${optional_vitamins[hashID]}</span>%</div></div>`
        ).appendTo("#infantvitaminsection");
      } else {
        $(
          `<div class="infantvitaminbullet">&#8226;</div><div class="infantvitaminright" data-test-id="vitamin-${vitaminID}">${vitaminDisplay} <span>${optional_vitamins[hashID]}</span>%</div><br style="clear:both">`
        ).insertAfter(".infantvitaminleft:last");
      }
      totalvitamins++;
    }
  } else if (isFormat("fda/infant/vertical")) {
    if (toggleBoolean) {
      if (totalvitamins > 0) {
        $('<div class="hairlineseparator"></div>').appendTo("#newinfantvitaminsection");
      }
      $(
        '<div class="new-vertical-row"><div class="pull-left"><div class="nutrientcontent">' +
          vitaminDisplay +
          " " +
          optional_vitamins[hashID][1] +
          optional_vitamins[hashID][0] +
          '</div></div><div class="pull-right"><div class="nutrientcontent">' +
          optional_vitamins[hashID][2] +
          '%</div></div><div class="clearfix"></div></div>'
      ).appendTo("#newinfantvitaminsection");
      totalvitamins++;
    }
  } else if (isFormat("fda/adult/vertical/as_prepared")) {
    if (toggleBoolean) {
      if (totalvitamins == 0) {
        $(
          '<div class="dual-left-col"><div class="thickseparator"></div></div><div class="dual-package-col"><div class="thickseparator"></div></div><div class="dual-serving-col"><div class="thickseparator"></div></div><div class="clearfix"></div>'
        ).appendTo("#newaspreparedvitaminsection");
      }
      if (totalvitamins > 0) {
        $(
          '<div class="dual-left-col"><div class="hairlineseparator"></div><div class="nutrientcontent">' +
            vitaminDisplay +
            '</div></div><div class="dual-package-col"><div class="hairlineseparator"></div><div class="pull-left"><div class="nutrient"><span class="nutrientcontent">' +
            optional_vitamins_2[hashID][1] +
            optional_vitamins_2[hashID][0] +
            '</span></div></div><div class="pull-right"><div class="nutrientcontent">' +
            optional_vitamins_2[hashID][2] +
            '%</div></div></div><div class="dual-serving-col"><div class="hairlineseparator"></div><div class="pull-left"><div class="nutrient"><span class="nutrientcontent">' +
            optional_vitamins[hashID][1] +
            optional_vitamins[hashID][0] +
            '</span></div></div><div class="pull-right"><div class="nutrientcontent">' +
            optional_vitamins[hashID][2] +
            '%</div></div></div><div class="clearfix"></div>'
        ).appendTo("#newaspreparedvitaminsection");
      } else {
        // no hairline separator
        $(
          '<div class="dual-left-col"><div class="nutrientcontent">' +
            vitaminDisplay +
            '</div></div><div class="dual-package-col"><div class="pull-left"><div class="nutrient"><span class="nutrientcontent">' +
            optional_vitamins_2[hashID][1] +
            optional_vitamins_2[hashID][0] +
            '</span></div></div><div class="pull-right"><div class="nutrientcontent">' +
            optional_vitamins_2[hashID][2] +
            '%</div></div></div><div class="dual-serving-col"><div class="pull-left"><div class="nutrient"><span class="nutrientcontent">' +
            optional_vitamins[hashID][1] +
            optional_vitamins[hashID][0] +
            '</span></div></div><div class="pull-right"><div class="nutrientcontent">' +
            optional_vitamins[hashID][2] +
            '%</div></div></div><div class="clearfix"></div>'
        ).appendTo("#newaspreparedvitaminsection");
      }
      totalvitamins++;
    }
  } else if (isFormat("fda/adult/vertical/aggregate")) {
    // List must be reversed due to the `float` rendering
    const vitaminsReversed = Array.from(aggregate_vitamins).reverse();
    if (toggleBoolean) {
      if (totalvitamins > 0) {
        $(
          '<div class="agg-vitamin-left-col"><div class="hairlineseparator"></div><div class="nutrientcontent">' +
            vitaminDisplay +
            "</div></div>"
        ).appendTo("#newaggregatevitaminsection");
        for (const vitamin of vitaminsReversed) {
          $(
            '<div class="agg-package-col"><div class="hairlineseparator"></div><div class="pull-left"><div class="nutrient"><span class="nutrientcontent">' +
              vitamin[hashID][1] +
              vitamin[hashID][0] +
              '</span></div></div><div class="pull-right"><div class="nutrientcontent">' +
              vitamin[hashID][2] +
              "%</div></div></div>"
          ).appendTo("#newaggregatevitaminsection");
        }
      } else {
        $(
          '<div class="agg-vitamin-left-col"><div class="nutrientcontent">' +
            vitaminDisplay +
            "</div></div>"
        ).appendTo("#newaggregatevitaminsection");
        for (const vitamin of vitaminsReversed) {
          $(
            '<div class="agg-package-col"><div class="pull-left"><div class="nutrient"><span class="nutrientcontent">' +
              vitamin[hashID][1] +
              vitamin[hashID][0] +
              '</span></div></div><div class="pull-right"><div class="nutrientcontent">' +
              vitamin[hashID][2] +
              "%</div></div></div>"
          ).appendTo("#newaggregatevitaminsection");
        }
      }
      $('<div class="clearfix"></div>').appendTo("#newaggregatevitaminsection");
      totalvitamins++;
    }
  } else if (isFormat("legacy_fda/child/vertical")) {
    if (toggleBoolean) {
      if (totalvitamins % 2 == 0) {
        $(
          `<div class="hairlineseparator"></div><div class="childvitamin" data-test-id="vitamin-${vitaminID}"><div class="childvitaminleft">${vitaminDisplay} <span>${optional_vitamins[hashID]}</span>%</div></div>`
        ).appendTo("#childvitaminsection");
      } else {
        $(
          `<div class="childvitaminbullet">&#8226;</div><div class="childvitaminright" data-test-id="vitamin-${vitaminID}">${vitaminDisplay} <span>${optional_vitamins[hashID]}</span>%</div><br style="clear:both">`
        ).insertAfter(".childvitaminleft:last");
      }
      totalvitamins++;
    }
  } else if (isFormat("fda/child/vertical")) {
    if (toggleBoolean) {
      if (totalvitamins > 0) {
        $('<div class="hairlineseparator"></div>').appendTo("#newchildvitaminsection");
      }
      $(
        '<div class="new-vertical-row"><div class="pull-left"><div class="nutrientcontent">' +
          vitaminDisplay +
          " " +
          optional_vitamins[hashID][1] +
          optional_vitamins[hashID][0] +
          '</div></div><div class="pull-right"><div class="nutrientcontent">' +
          optional_vitamins[hashID][2] +
          '%</div></div><div class="clearfix"></div></div>'
      ).appendTo("#newchildvitaminsection");
      totalvitamins++;
    }
  }
  //for linear label - insert if toggled
  else if (isFormat("legacy_fda/adult/linear")) {
    if (toggleBoolean) {
      $(
        '<span class="linearnutrientcontent linearvitamins">,&#8197;</span><span class="linearnutrientcontent linearvitamins">' +
          vitaminDisplay +
          "&#8197;</span>" +
          '<span class="linearnutrientcontent linearvitamins">(' +
          optional_vitamins[hashID] +
          "% DV)</span>"
      ).insertBefore("#endofvitamins");
    }
  } else if (isFormat("fda/adult/linear")) {
    if (toggleBoolean) {
      $(
        '<span class="linearnutrientcontent linearvitamins">,&#8197;</span><span class="linearnutrientcontent linearvitamins">' +
          vitaminDisplay +
          "&#8197;</span>" +
          '<span class="linearnutrientcontent linearvitamins">(' +
          optional_vitamins[hashID][2] +
          "% DV)</span>"
      ).insertBefore("#endofvitaminsnewlinear");
    }
  } else if (isFormat("legacy_fda/adult/tabular")) {
    if (toggleBoolean) {
      if (totalvitamins == 0) {
        $('<div class="vitamintabularrow"></div><div class="clearfix"></div>').appendTo(
          "#vitaminsectiontabular"
        );
        $(".vitamintabularrow:last").html(vitaminDisplay + " " + optional_vitamins[hashID] + "%");
      } else {
        $(".vitamintabularrow:last").html(
          $(".vitamintabularrow:last").html() +
            " &#8226; " +
            vitaminDisplay +
            " " +
            optional_vitamins[hashID] +
            "%"
        );
        // bullet margins depend on slider so have to fix new bullets before
        // calculating width...
        refreshSlider("#tabularslider");
        // check how wide current row is - if wider than row, remove last vitamin
        // and put in next row
        /*var sum = 0;
          $.each($('.vitamintabularrow:last .vitamintabular, .vitamintabularrow:last .vitaminbullettabular'), function(index, value) { sum = sum + $(value).outerWidth(true); });
          if (sum > ($('#tabular_nutrient_cols').width())) {
            $('.vitamintabular:last, .vitaminbullettabular:last').remove();
            $('<div class="vitamintabularrow"></div>').appendTo('#vitaminsectiontabular');
            $('<div class="vitamintabular">' + vitaminDisplay + ' ' + optional_vitamins[hashID] + '%</div>').appendTo('.vitamintabularrow:last');
          }*/
        // check height of row instead, since it's now one row instead of separate divs
        if ($(".vitamintabularrow:last").outerHeight() > 11 * 1.5) {
          let vitaminrowarray = $(".vitamintabularrow:last").html().split(" • ");
          vitaminrowarray.pop();

          $(".vitamintabularrow:last").html(vitaminrowarray.join(" • "));
          $('<div class="vitamintabularrow"></div><div class="clearfix"></div>').appendTo(
            "#vitaminsectiontabular"
          );
          $(".vitamintabularrow:last").html(vitaminDisplay + " " + optional_vitamins[hashID] + "%");
        }
      }
      totalvitamins++;
    }
  } else if (isFormat("fda/adult/tabular")) {
    if ($("#new_tabular_dual_nutrient_cols").length > 0) {
      if (toggleBoolean) {
        if (totalvitamins > 0) {
          $(
            '<div class="newtabulardualvitaminrow"><div class="tabular-dual-left-col"><div class="hairlineseparator"></div><div class="nutrientcontent">' +
              vitaminDisplay +
              '</div></div><div class="tabular-dual-package-col"><div class="hairlineseparator"></div><div class="pull-left"><div class="nutrient"><span class="nutrientcontent">' +
              optional_vitamins_2[hashID][1] +
              optional_vitamins_2[hashID][0] +
              '</span></div></div><div class="pull-right"><div class="nutrientcontent">' +
              optional_vitamins_2[hashID][2] +
              '%</div></div></div><div class="tabular-dual-serving-col"><div class="hairlineseparator"></div><div class="pull-left"><div class="nutrient"><span class="nutrientcontent">' +
              optional_vitamins[hashID][1] +
              optional_vitamins[hashID][0] +
              '</span></div></div><div class="pull-right"><div class="nutrientcontent">' +
              optional_vitamins[hashID][2] +
              '%</div></div></div><div class="clearfix"></div></div>'
          ).insertBefore("#new_vitamin_filler_col_2");
        } else {
          $(
            '<div class="newtabulardualvitaminrow"><div class="tabular-dual-left-col"><div class="separator"></div><div class="nutrientcontent">' +
              vitaminDisplay +
              '</div></div><div class="tabular-dual-package-col"><div class="separator"></div><div class="pull-left"><div class="nutrient"><span class="nutrientcontent">' +
              optional_vitamins_2[hashID][1] +
              optional_vitamins_2[hashID][0] +
              '</span></div></div><div class="pull-right"><div class="nutrientcontent">' +
              optional_vitamins_2[hashID][2] +
              '%</div></div></div><div class="tabular-dual-serving-col"><div class="separator"></div><div class="pull-left"><div class="nutrient"><span class="nutrientcontent">' +
              optional_vitamins[hashID][1] +
              optional_vitamins[hashID][0] +
              '</span></div></div><div class="pull-right"><div class="nutrientcontent">' +
              optional_vitamins[hashID][2] +
              '%</div></div></div><div class="clearfix"></div></div><div class="newtabulardualvitaminrow" id="new_vitamin_filler_col_2"><div class="tabular-dual-left-col"><div class="hairlineseparator"></div><div class="nutrientcontent" style="opacity:0;">filler</div></div><div class="tabular-dual-package-col"><div class="hairlineseparator"></div><div class="pull-left"><div class="nutrient" style="opacity:0;"><span class="nutrientcontent" style="opacity:0;">0mg</span></div></div><div class="pull-right"><div class="nutrientcontent" style="opacity:0;">0%</div></div></div><div class="tabular-dual-serving-col"><div class="hairlineseparator"></div><div class="pull-left"><div class="nutrient" style="opacity:0;"><span class="nutrientcontent" style="opacity:0;">0mg</span></div></div><div class="pull-right"><div class="nutrientcontent" style="opacity:0;">0%</div></div></div><div class="clearfix"></div></div>'
          ).appendTo("#vitaminsectionnewtabular .new_tabular_dual_nutrient_col:first");
        }
        totalvitamins++;
      }
    } else {
      if (toggleBoolean) {
        if (totalvitamins == 0) {
          $('<div class="vitaminnewtabularrow"></div><div class="clearfix"></div>').appendTo(
            "#vitaminsectionnewtabular"
          );
          $(".vitaminnewtabularrow:last").html(
            vitaminDisplay +
              " " +
              optional_vitamins[hashID][1] +
              optional_vitamins[hashID][0] +
              " " +
              optional_vitamins[hashID][2] +
              "%"
          );
        } else {
          $(".vitaminnewtabularrow:last").html(
            $(".vitaminnewtabularrow:last").html() +
              " &#8226; " +
              vitaminDisplay +
              " " +
              optional_vitamins[hashID][1] +
              optional_vitamins[hashID][0] +
              " " +
              optional_vitamins[hashID][2] +
              "%"
          );
          refreshSlider("#newtabularslider");
          // Check height of row instead, since it's now one row instead of separate divs.
          // Allow for line-height: A line-break won't just *slightly* exceed the natural
          // height of the row: It'll blast through it.
          if ($(".vitaminnewtabularrow:last").outerHeight() > 11 * 1.5) {
            let vitaminrowarray = $(".vitaminnewtabularrow:last").html().split(" • ");
            vitaminrowarray.pop();
            $(".vitaminnewtabularrow:last").html(vitaminrowarray.join(" • "));
            $('<div class="vitaminnewtabularrow"></div><div class="clearfix"></div>').appendTo(
              "#vitaminsectionnewtabular"
            );
            $(".vitaminnewtabularrow:last").html(
              vitaminDisplay +
                " " +
                optional_vitamins[hashID][1] +
                optional_vitamins[hashID][0] +
                " " +
                optional_vitamins[hashID][2] +
                "%"
            );
          }
        }
        totalvitamins++;
      }
    }
  }
}

export function rebuildFunction() {
  totalvitamins = 0;

  //remove all vitamins before adding them
  onFormat({
    "legacy_fda/adult/vertical"() {
      while ($(".vitamin").length > 0) {
        $(".vitamin:last").next(".hairlineseparator").remove();
        $(".vitamin:last").remove();
      }
    },
    "fda/adult/vertical"() {
      $("#newverticalvitaminsection").empty();
    },
    "canada/adult/vertical"() {
      $("#newcanadavitaminsection").empty();
    },
    "canada/adult/linear"() {
      $(".linearvitamins").remove();
    },
    "canada/adult/tabular"() {
      $(".CaTabularNFP-Nutrient--optional, .CaTabularNFP-NutrientCol--optional").remove();
    },
    "canada/adult/vertical/as_prepared"() {
      $("#newcanadavitaminsection").empty();
    },
    "canada/adult/vertical/aggregate"() {
      $("#ca-aggregate-vitamin-section").empty();
    },
    "legacy_fda/adult/linear"() {
      $(".linearvitamins").remove();
    },
    "fda/adult/linear"() {
      $(".linearvitamins").remove();
    },
    "legacy_fda/adult/vertical/as_prepared"() {
      $("#aggregate-vitaminsection").empty();
    },
    "fda/adult/vertical/as_prepared"() {
      $("#newaspreparedvitaminsection").empty();
    },
    "fda/adult/vertical/aggregate"() {
      $("#newaggregatevitaminsection").empty();
    },
    "legacy_fda/adult/tabular"() {
      $(".vitamintabularrow, .vitamintabular, .vitaminbullettabular").remove();
    },
    "fda/adult/tabular"() {
      $(".vitaminnewtabularrow").remove();
      $(".newtabulardualvitaminrow").remove();
    },
    "legacy_fda/infant/vertical"() {
      $(".infantvitamin, #infantvitaminsection .hairlineseparator").remove();
    },
    "legacy_fda/child/vertical"() {
      $(".childvitamin, #childvitaminsection .hairlineseparator").remove();
    },
    "fda/infant/vertical"() {
      $("#newinfantvitaminsection").empty();
    },
    "fda/child/vertical"() {
      $("#newchildvitaminsection").empty();
    },
  });

  //if simplified format, add vitamins only if they are 'significant', otherwise add everything
  if ($("#simplifiedformattoggle").is(":checked")) {
    optionalVitaminTogglesRebuild(
      simplified_hash["vitamin_a_IU"] == false,
      "vitaminA",
      "Vitamin A",
      "vitamin_a"
    );
    optionalVitaminTogglesRebuild(
      simplified_hash["vitamin_c"] == false,
      "vitaminC",
      "Vitamin C",
      "vitamin_c"
    );
    optionalVitaminTogglesRebuild(
      simplified_hash["calcium"] == false,
      "calcium",
      "Calcium",
      "calcium"
    );
    optionalVitaminTogglesRebuild(simplified_hash["iron"] == false, "iron", "Iron", "iron");
  } else if ($("#newsimplifiedformattoggle").is(":checked")) {
    if (
      isFormat("fda/adult/vertical") ||
      isFormat("fda/adult/tabular") ||
      isFormat("fda/adult/vertical/as_prepared")
    ) {
      optionalVitaminTogglesRebuild(
        visibleWithToggle("vitamin_d", simplified_hash["vitamin_d"] == false),
        "vitaminD",
        "Vitamin D",
        "vitamin_d"
      );
      optionalVitaminTogglesRebuild(
        visibleWithToggle("calcium", simplified_hash["calcium"] == false),
        "calcium",
        "Calcium",
        "calcium"
      );
      optionalVitaminTogglesRebuild(
        visibleWithToggle("iron", simplified_hash["iron"] == false),
        "iron",
        "Iron",
        "iron"
      );
      optionalVitaminTogglesRebuild(
        visibleWithToggle("potassium", simplified_hash["potassium"] == false),
        "potassium",
        "Potassium",
        "potassium"
      );
    } else if (isFormat("fda/adult/linear")) {
      optionalVitaminTogglesRebuild(
        visibleWithToggle("vitamin_d", simplified_hash["vitamin_d"] == false),
        "vitaminD",
        "Vit. D",
        "vitamin_d"
      );
      optionalVitaminTogglesRebuild(
        visibleWithToggle("calcium", simplified_hash["calcium"] == false),
        "calcium",
        "Calcium",
        "calcium"
      );
      optionalVitaminTogglesRebuild(
        visibleWithToggle("iron", simplified_hash["iron"] == false),
        "iron",
        "Iron",
        "iron"
      );
      optionalVitaminTogglesRebuild(
        visibleWithToggle("potassium", simplified_hash["potassium"] == false),
        "potassium",
        "Potas.",
        "potassium"
      );
    }
  } else if ($("#newaggregatesimplifiedformattoggle").is(":checked")) {
    if (isFormat("fda/adult/vertical/aggregate")) {
      optionalVitaminTogglesRebuild(
        visibleWithToggle("vitamin_d", simplified_hash["vitamin_d"] == false),
        "vitaminD",
        "Vitamin D",
        "vitamin_d"
      );
      optionalVitaminTogglesRebuild(
        visibleWithToggle("calcium", simplified_hash["calcium"] == false),
        "calcium",
        "Calcium",
        "calcium"
      );
      optionalVitaminTogglesRebuild(
        visibleWithToggle("iron", simplified_hash["iron"] == false),
        "iron",
        "Iron",
        "iron"
      );
      optionalVitaminTogglesRebuild(
        visibleWithToggle("potassium", simplified_hash["potassium"] == false),
        "potassium",
        "Potassium",
        "potassium"
      );
    }
  } else if ($("#newcanadasimplifiedformattoggle").is(":checked")) {
    if (isFormat("canada/adult/vertical") || isFormat("canada/adult/vertical/aggregate")) {
      optionalVitaminTogglesRebuild(
        simplified_hash["potassium"] == false,
        "potassium",
        "Potassium",
        "potassium"
      );
      optionalVitaminTogglesRebuild(
        simplified_hash["calcium"] == false,
        "calcium",
        "Calcium",
        "calcium"
      );
      optionalVitaminTogglesRebuild(simplified_hash["iron"] == false, "iron", "Iron / Fer", "iron");
    } else if (isFormat("canada/adult/linear")) {
      const enContainer = { end: $(".endofvitaminsnewlinearcanada.english") };
      optionalVitaminTogglesRebuild(
        simplified_hash["potassium"] == false,
        "potassium",
        "Potassium",
        "potassium",
        enContainer
      );
      optionalVitaminTogglesRebuild(
        simplified_hash["calcium"] == false,
        "calcium",
        "Calcium",
        "calcium",
        enContainer
      );
      optionalVitaminTogglesRebuild(
        simplified_hash["iron"] == false,
        "iron",
        "Iron",
        "iron",
        enContainer
      );
      const frContainer = { end: $(".endofvitaminsnewlinearcanada.french") };
      optionalVitaminTogglesRebuild(
        simplified_hash["potassium"] == false,
        "potassium",
        "Potassium",
        "potassium",
        frContainer
      );
      optionalVitaminTogglesRebuild(
        simplified_hash["calcium"] == false,
        "calcium",
        "Calcium",
        "calcium",
        frContainer
      );
      optionalVitaminTogglesRebuild(
        simplified_hash["iron"] == false,
        "iron",
        "Fer",
        "iron",
        frContainer
      );
    }
  } else {
    if (isFormat("legacy_fda/infant/vertical") || isFormat("legacy_fda/child/vertical")) {
      optionalVitaminTogglesRebuild(true, "protein", "Protein", "protein");
    }
    // rebuild these no matter what
    if (
      isFormat("fda/adult/vertical") ||
      isFormat("fda/adult/tabular") ||
      isFormat("fda/infant/vertical") ||
      isFormat("fda/child/vertical") ||
      isFormat("fda/adult/vertical/as_prepared") ||
      isFormat("fda/adult/vertical/aggregate")
    ) {
      optionalVitaminTogglesRebuild(
        visibleWithToggle("vitamin_d", true),
        "vitaminD",
        "Vitamin D",
        "vitamin_d"
      );
      optionalVitaminTogglesRebuild(
        visibleWithToggle("calcium", true),
        "calcium",
        "Calcium",
        "calcium"
      );
      optionalVitaminTogglesRebuild(visibleWithToggle("iron", true), "iron", "Iron", "iron");
      optionalVitaminTogglesRebuild(
        visibleWithToggle("potassium", true),
        "potassium",
        "Potassium",
        "potassium"
      );
    } else if (isFormat("fda/adult/linear")) {
      optionalVitaminTogglesRebuild(
        visibleWithToggle("vitamin_d", true),
        "vitaminD",
        "Vit. D",
        "vitamin_d"
      );
      optionalVitaminTogglesRebuild(
        visibleWithToggle("calcium", true),
        "calcium",
        "Calcium",
        "calcium"
      );
      optionalVitaminTogglesRebuild(visibleWithToggle("iron", true), "iron", "Iron", "iron");
      optionalVitaminTogglesRebuild(
        visibleWithToggle("potassium", true),
        "potassium",
        "Potas.",
        "potassium"
      );
    } else if (
      isFormat("canada/adult/vertical") ||
      isFormat("canada/adult/vertical/as_prepared") ||
      isFormat("canada/adult/vertical/aggregate")
    ) {
      optionalVitaminTogglesRebuild(true, "potassium", "Potassium", "potassium");
      optionalVitaminTogglesRebuild(true, "calcium", "Calcium", "calcium");
      optionalVitaminTogglesRebuild(true, "iron", "Iron / Fer", "iron");
    } else if (isFormat("canada/adult/linear")) {
      const enContainer = { end: $(".endofvitaminsnewlinearcanada.english") };
      optionalVitaminTogglesRebuild(true, "potassium", "Potassium", "potassium", enContainer);
      optionalVitaminTogglesRebuild(true, "calcium", "Calcium", "calcium", enContainer);
      optionalVitaminTogglesRebuild(true, "iron", "Iron", "iron", enContainer);
      const frContainer = { end: $(".endofvitaminsnewlinearcanada.french") };
      optionalVitaminTogglesRebuild(true, "potassium", "Potassium", "potassium", frContainer);
      optionalVitaminTogglesRebuild(true, "calcium", "Calcium", "calcium", frContainer);
      optionalVitaminTogglesRebuild(true, "iron", "Fer", "iron", frContainer);
    } else if (isFormat("canada/adult/tabular")) {
      optionalVitaminTogglesRebuild(true, "potassium", "Potassium", "potassium");
      optionalVitaminTogglesRebuild(true, "calcium", "Calcium", "calcium");
      optionalVitaminTogglesRebuild(true, "iron", "Iron / Fer", "iron");
    } else {
      optionalVitaminTogglesRebuild(true, "vitaminA", "Vitamin A", "vitamin_a");
      optionalVitaminTogglesRebuild(true, "vitaminC", "Vitamin C", "vitamin_c");
      optionalVitaminTogglesRebuild(true, "calcium", "Calcium", "calcium");
      optionalVitaminTogglesRebuild(true, "iron", "Iron", "iron");
    }
  }

  //add them back one by one, in order - will only add if it is checked currently
  if (
    isFormat("fda/adult/vertical") ||
    isFormat("fda/adult/tabular") ||
    isFormat("fda/infant/vertical") ||
    isFormat("fda/child/vertical") ||
    isFormat("fda/adult/vertical/as_prepared") ||
    isFormat("fda/adult/vertical/aggregate")
  ) {
    optionalVitaminTogglesRebuild(
      $("#vitaminAtoggle").is(":checked"),
      "vitaminA",
      "Vitamin A",
      "vitamin_a"
    );
    optionalVitaminTogglesRebuild(
      $("#vitaminCtoggle").is(":checked"),
      "vitaminC",
      "Vitamin C",
      "vitamin_c"
    );
    optionalVitaminTogglesRebuild(
      $("#vitaminEtoggle").is(":checked"),
      "vitaminE",
      "Vitamin E",
      "vitamin_e"
    );
    optionalVitaminTogglesRebuild(
      $("#vitaminKtoggle").is(":checked"),
      "vitaminK",
      "Vitamin K",
      "vitamin_k"
    );
    optionalVitaminTogglesRebuild(
      $("#thiamintoggle").is(":checked"),
      "thiamin",
      "Thiamin",
      "thiamin"
    );
    optionalVitaminTogglesRebuild(
      $("#riboflavintoggle").is(":checked"),
      "riboflavin",
      "Riboflavin",
      "riboflavin"
    );
    optionalVitaminTogglesRebuild($("#niacintoggle").is(":checked"), "niacin", "Niacin", "niacin");
    optionalVitaminTogglesRebuild(
      $("#vitaminB6toggle").is(":checked"),
      "vitaminB6",
      "Vitamin B6",
      "vitamin_b6"
    );
    optionalVitaminTogglesRebuild($("#folatetoggle").is(":checked"), "folate", "Folate", "folate");
    optionalVitaminTogglesRebuild(
      $("#vitaminB12toggle").is(":checked"),
      "vitaminB12",
      "Vitamin B12",
      "vitamin_b12"
    );
    optionalVitaminTogglesRebuild($("#biotintoggle").is(":checked"), "biotin", "Biotin", "biotin");
    optionalVitaminTogglesRebuild(
      $("#pantothenicacidtoggle").is(":checked"),
      "pantothenic",
      "Pantothenic Acid",
      "pantothenic_acid"
    );
    optionalVitaminTogglesRebuild(
      $("#phosphorustoggle").is(":checked"),
      "phosphorus",
      "Phosphorus",
      "phosphorus"
    );
    optionalVitaminTogglesRebuild($("#iodinetoggle").is(":checked"), "iodine", "Iodine", "iodine");
    optionalVitaminTogglesRebuild(
      $("#magnesiumtoggle").is(":checked"),
      "magnesium",
      "Magnesium",
      "magnesium"
    );
    optionalVitaminTogglesRebuild($("#zinctoggle").is(":checked"), "zinc", "Zinc", "zinc");
    optionalVitaminTogglesRebuild(
      $("#seleniumtoggle").is(":checked"),
      "selenium",
      "Selenium",
      "selenium"
    );
    optionalVitaminTogglesRebuild($("#coppertoggle").is(":checked"), "copper", "Copper", "copper");
    optionalVitaminTogglesRebuild(
      $("#manganesetoggle").is(":checked"),
      "manganese",
      "Manganese",
      "manganese"
    );
    optionalVitaminTogglesRebuild(
      $("#chromiumtoggle").is(":checked"),
      "chromium",
      "Chromium",
      "chromium"
    );
    optionalVitaminTogglesRebuild(
      $("#molybdenumtoggle").is(":checked"),
      "molybdenum",
      "Molybdenum",
      "molybdenum"
    );
    optionalVitaminTogglesRebuild(
      $("#chloridetoggle").is(":checked"),
      "chloride",
      "Chloride",
      "chloride"
    );
    optionalVitaminTogglesRebuild(
      $("#cholinetoggle").is(":checked"),
      "choline",
      "Choline",
      "choline"
    );
    if ($("#new_tabular_dual_nutrient_cols").length > 0) {
      $("#new_vitamin_filler_col_2").show();
      tabularVitaminShuffle();
    }

    if (isFormat("fda/adult/vertical/aggregate")) {
      $("#newaggregatevitaminsection").toggleClass("novitamins", totalvitamins === 0);
    }
  } else if (isFormat("fda/adult/linear")) {
    optionalVitaminTogglesRebuild(
      $("#vitaminAtoggle").is(":checked"),
      "vitaminA",
      "Vit. A",
      "vitamin_a"
    );
    optionalVitaminTogglesRebuild(
      $("#vitaminCtoggle").is(":checked"),
      "vitaminC",
      "Vit. C",
      "vitamin_c"
    );
    optionalVitaminTogglesRebuild(
      $("#vitaminEtoggle").is(":checked"),
      "vitaminE",
      "Vit. E",
      "vitamin_e"
    );
    optionalVitaminTogglesRebuild(
      $("#vitaminKtoggle").is(":checked"),
      "vitaminK",
      "Vit. K",
      "vitamin_k"
    );
    optionalVitaminTogglesRebuild(
      $("#thiamintoggle").is(":checked"),
      "thiamin",
      "Thiamin",
      "thiamin"
    );
    optionalVitaminTogglesRebuild(
      $("#riboflavintoggle").is(":checked"),
      "riboflavin",
      "Riboflavin",
      "riboflavin"
    );
    optionalVitaminTogglesRebuild($("#niacintoggle").is(":checked"), "niacin", "Niacin", "niacin");
    optionalVitaminTogglesRebuild(
      $("#vitaminB6toggle").is(":checked"),
      "vitaminB6",
      "Vit. B6",
      "vitamin_b6"
    );
    optionalVitaminTogglesRebuild($("#folatetoggle").is(":checked"), "folate", "Folate", "folate");
    optionalVitaminTogglesRebuild(
      $("#vitaminB12toggle").is(":checked"),
      "vitaminB12",
      "Vit. B12",
      "vitamin_b12"
    );
    optionalVitaminTogglesRebuild($("#biotintoggle").is(":checked"), "biotin", "Biotin", "biotin");
    optionalVitaminTogglesRebuild(
      $("#pantothenicacidtoggle").is(":checked"),
      "pantothenic",
      "Pantothenic Acid",
      "pantothenic_acid"
    );
    optionalVitaminTogglesRebuild(
      $("#phosphorustoggle").is(":checked"),
      "phosphorus",
      "Phosphorus",
      "phosphorus"
    );
    optionalVitaminTogglesRebuild($("#iodinetoggle").is(":checked"), "iodine", "Iodine", "iodine");
    optionalVitaminTogglesRebuild(
      $("#magnesiumtoggle").is(":checked"),
      "magnesium",
      "Magnesium",
      "magnesium"
    );
    optionalVitaminTogglesRebuild($("#zinctoggle").is(":checked"), "zinc", "Zinc", "zinc");
    optionalVitaminTogglesRebuild(
      $("#seleniumtoggle").is(":checked"),
      "selenium",
      "Selenium",
      "selenium"
    );
    optionalVitaminTogglesRebuild($("#coppertoggle").is(":checked"), "copper", "Copper", "copper");
    optionalVitaminTogglesRebuild(
      $("#manganesetoggle").is(":checked"),
      "manganese",
      "Manganese",
      "manganese"
    );
    optionalVitaminTogglesRebuild(
      $("#chromiumtoggle").is(":checked"),
      "chromium",
      "Chromium",
      "chromium"
    );
    optionalVitaminTogglesRebuild(
      $("#molybdenumtoggle").is(":checked"),
      "molybdenum",
      "Molybdenum",
      "molybdenum"
    );
    optionalVitaminTogglesRebuild(
      $("#chloridetoggle").is(":checked"),
      "chloride",
      "Chloride",
      "chloride"
    );
    optionalVitaminTogglesRebuild(
      $("#cholinetoggle").is(":checked"),
      "choline",
      "Choline",
      "choline"
    );
  } else if (
    isFormat("canada/adult/vertical") ||
    isFormat("canada/adult/tabular") ||
    isFormat("canada/adult/vertical/as_prepared") ||
    isFormat("canada/adult/vertical/aggregate")
  ) {
    // change display for canadian version
    optionalVitaminTogglesRebuild(
      $("#vitaminAtoggle").is(":checked"),
      "vitaminA",
      "Vitamin A / Vitamine A",
      "vitamin_a"
    );
    optionalVitaminTogglesRebuild(
      $("#vitaminCtoggle").is(":checked"),
      "vitaminC",
      "Vitamin C / Vitamine C",
      "vitamin_c"
    );
    optionalVitaminTogglesRebuild(
      $("#vitaminDtoggle").is(":checked"),
      "vitaminD",
      "Vitamin D / Vitamine D",
      "vitamin_d"
    );
    optionalVitaminTogglesRebuild(
      $("#vitaminEtoggle").is(":checked"),
      "vitaminE",
      "Vitamin E / Vitamine E",
      "vitamin_e"
    );
    optionalVitaminTogglesRebuild(
      $("#vitaminKtoggle").is(":checked"),
      "vitaminK",
      "Vitamin K / Vitamine K",
      "vitamin_k"
    );
    optionalVitaminTogglesRebuild(
      $("#thiamintoggle").is(":checked"),
      "thiamin",
      "Thiamine",
      "thiamin"
    );
    optionalVitaminTogglesRebuild(
      $("#riboflavintoggle").is(":checked"),
      "riboflavin",
      "Riboflavin / Riboflavine",
      "riboflavin"
    );
    optionalVitaminTogglesRebuild(
      $("#niacintoggle").is(":checked"),
      "niacin",
      "Niacin / Niacine",
      "niacin"
    );
    optionalVitaminTogglesRebuild(
      $("#vitaminB6toggle").is(":checked"),
      "vitaminB6",
      "Vitamin B6 / Vitamine B6",
      "vitamin_b6"
    );
    optionalVitaminTogglesRebuild($("#folatetoggle").is(":checked"), "folate", "Folate", "folate");
    optionalVitaminTogglesRebuild(
      $("#vitaminB12toggle").is(":checked"),
      "vitaminB12",
      "Vitamin B12 / Vitamine B12",
      "vitamin_b12"
    );
    optionalVitaminTogglesRebuild(
      $("#biotintoggle").is(":checked"),
      "biotin",
      "Biotin / Biotine",
      "biotin"
    );
    optionalVitaminTogglesRebuild(
      $("#pantothenicacidtoggle").is(":checked"),
      "pantothenic",
      "Pantothenic Acid / Pantothénate",
      "pantothenic_acid"
    );
    optionalVitaminTogglesRebuild(
      $("#phosphorustoggle").is(":checked"),
      "phosphorus",
      "Phosphorus / Phosphore",
      "phosphorus"
    );
    optionalVitaminTogglesRebuild(
      $("#iodinetoggle").is(":checked"),
      "iodine",
      "Iodine / Iode",
      "iodine"
    );
    optionalVitaminTogglesRebuild(
      $("#magnesiumtoggle").is(":checked"),
      "magnesium",
      "Magnesium / Magnésium",
      "magnesium"
    );
    optionalVitaminTogglesRebuild($("#zinctoggle").is(":checked"), "zinc", "Zinc", "zinc");
    optionalVitaminTogglesRebuild(
      $("#seleniumtoggle").is(":checked"),
      "selenium",
      "Selenium / Sélénium",
      "selenium"
    );
    optionalVitaminTogglesRebuild(
      $("#coppertoggle").is(":checked"),
      "copper",
      "Copper / Cuivre",
      "copper"
    );
    optionalVitaminTogglesRebuild(
      $("#manganesetoggle").is(":checked"),
      "manganese",
      "Manganese / Manganèse",
      "manganese"
    );
    optionalVitaminTogglesRebuild(
      $("#chromiumtoggle").is(":checked"),
      "chromium",
      "Chromium / Chrome",
      "chromium"
    );
    optionalVitaminTogglesRebuild(
      $("#molybdenumtoggle").is(":checked"),
      "molybdenum",
      "Molybdenum / Molybdène",
      "molybdenum"
    );
    optionalVitaminTogglesRebuild(
      $("#chloridetoggle").is(":checked"),
      "chloride",
      "Chloride / Chlorure",
      "chloride"
    );
    optionalVitaminTogglesRebuild(
      $("#cholinetoggle").is(":checked"),
      "choline",
      "Choline",
      "choline"
    );
  } else if (isFormat("canada/adult/linear")) {
    // change display for canadian version
    const enContainer = { end: $(".endofvitaminsnewlinearcanada.english") };
    optionalVitaminTogglesRebuild(
      $("#vitaminAtoggle").is(":checked"),
      "vitaminA",
      "Vitamin A",
      "vitamin_a",
      enContainer
    );
    optionalVitaminTogglesRebuild(
      $("#vitaminCtoggle").is(":checked"),
      "vitaminC",
      "Vitamin C",
      "vitamin_c",
      enContainer
    );
    optionalVitaminTogglesRebuild(
      $("#vitaminDtoggle").is(":checked"),
      "vitaminD",
      "Vitamin D",
      "vitamin_d",
      enContainer
    );
    optionalVitaminTogglesRebuild(
      $("#vitaminEtoggle").is(":checked"),
      "vitaminE",
      "Vitamin E",
      "vitamin_e",
      enContainer
    );
    optionalVitaminTogglesRebuild(
      $("#vitaminKtoggle").is(":checked"),
      "vitaminK",
      "Vitamin K",
      "vitamin_k",
      enContainer
    );
    optionalVitaminTogglesRebuild(
      $("#thiamintoggle").is(":checked"),
      "thiamin",
      "Thiamine",
      "thiamin",
      enContainer
    );
    optionalVitaminTogglesRebuild(
      $("#riboflavintoggle").is(":checked"),
      "riboflavin",
      "Riboflavin",
      "riboflavin",
      enContainer
    );
    optionalVitaminTogglesRebuild(
      $("#niacintoggle").is(":checked"),
      "niacin",
      "Niacin",
      "niacin",
      enContainer
    );
    optionalVitaminTogglesRebuild(
      $("#vitaminB6toggle").is(":checked"),
      "vitaminB6",
      "Vitamin B6",
      "vitamin_b6",
      enContainer
    );
    optionalVitaminTogglesRebuild(
      $("#folatetoggle").is(":checked"),
      "folate",
      "Folate",
      "folate",
      enContainer
    );
    optionalVitaminTogglesRebuild(
      $("#vitaminB12toggle").is(":checked"),
      "vitaminB12",
      "Vitamin B12",
      "vitamin_b12",
      enContainer
    );
    optionalVitaminTogglesRebuild(
      $("#biotintoggle").is(":checked"),
      "biotin",
      "Biotin",
      "biotin",
      enContainer
    );
    optionalVitaminTogglesRebuild(
      $("#pantothenicacidtoggle").is(":checked"),
      "pantothenic",
      "Pantothenic Acid",
      "pantothenic_acid",
      enContainer
    );
    optionalVitaminTogglesRebuild(
      $("#phosphorustoggle").is(":checked"),
      "phosphorus",
      "Phosphorus",
      "phosphorus",
      enContainer
    );
    optionalVitaminTogglesRebuild(
      $("#iodinetoggle").is(":checked"),
      "iodine",
      "Iodine",
      "iodine",
      enContainer
    );
    optionalVitaminTogglesRebuild(
      $("#magnesiumtoggle").is(":checked"),
      "magnesium",
      "Magnesium",
      "magnesium",
      enContainer
    );
    optionalVitaminTogglesRebuild(
      $("#zinctoggle").is(":checked"),
      "zinc",
      "Zinc",
      "zinc",
      enContainer
    );
    optionalVitaminTogglesRebuild(
      $("#seleniumtoggle").is(":checked"),
      "selenium",
      "Selenium",
      "selenium",
      enContainer
    );
    optionalVitaminTogglesRebuild(
      $("#coppertoggle").is(":checked"),
      "copper",
      "Copper",
      "copper",
      enContainer
    );
    optionalVitaminTogglesRebuild(
      $("#manganesetoggle").is(":checked"),
      "manganese",
      "Manganese",
      "manganese",
      enContainer
    );
    optionalVitaminTogglesRebuild(
      $("#chromiumtoggle").is(":checked"),
      "chromium",
      "Chromium",
      "chromium",
      enContainer
    );
    optionalVitaminTogglesRebuild(
      $("#molybdenumtoggle").is(":checked"),
      "molybdenum",
      "Molybdenum",
      "molybdenum",
      enContainer
    );
    optionalVitaminTogglesRebuild(
      $("#chloridetoggle").is(":checked"),
      "chloride",
      "Chloride",
      "chloride",
      enContainer
    );
    optionalVitaminTogglesRebuild(
      $("#cholinetoggle").is(":checked"),
      "choline",
      "Choline",
      "choline",
      enContainer
    );

    const frContainer = { end: $(".endofvitaminsnewlinearcanada.french") };
    optionalVitaminTogglesRebuild(
      $("#vitaminAtoggle").is(":checked"),
      "vitaminA",
      "Vitamine A",
      "vitamin_a",
      frContainer
    );
    optionalVitaminTogglesRebuild(
      $("#vitaminCtoggle").is(":checked"),
      "vitaminC",
      "Vitamine C",
      "vitamin_c",
      frContainer
    );
    optionalVitaminTogglesRebuild(
      $("#vitaminDtoggle").is(":checked"),
      "vitaminD",
      "Vitamine D",
      "vitamin_d",
      frContainer
    );
    optionalVitaminTogglesRebuild(
      $("#vitaminEtoggle").is(":checked"),
      "vitaminE",
      "Vitamine E",
      "vitamin_e",
      frContainer
    );
    optionalVitaminTogglesRebuild(
      $("#vitaminKtoggle").is(":checked"),
      "vitaminK",
      "Vitamine K",
      "vitamin_k",
      frContainer
    );
    optionalVitaminTogglesRebuild(
      $("#thiamintoggle").is(":checked"),
      "thiamin",
      "Thiamine",
      "thiamin",
      frContainer
    );
    optionalVitaminTogglesRebuild(
      $("#riboflavintoggle").is(":checked"),
      "riboflavin",
      "Riboflavine",
      "riboflavin",
      frContainer
    );
    optionalVitaminTogglesRebuild(
      $("#niacintoggle").is(":checked"),
      "niacin",
      "Niacine",
      "niacin",
      frContainer
    );
    optionalVitaminTogglesRebuild(
      $("#vitaminB6toggle").is(":checked"),
      "vitaminB6",
      "Vitamine B6",
      "vitamin_b6",
      frContainer
    );
    optionalVitaminTogglesRebuild(
      $("#folatetoggle").is(":checked"),
      "folate",
      "Folate",
      "folate",
      frContainer
    );
    optionalVitaminTogglesRebuild(
      $("#vitaminB12toggle").is(":checked"),
      "vitaminB12",
      "Vitamine B12",
      "vitamin_b12",
      frContainer
    );
    optionalVitaminTogglesRebuild(
      $("#biotintoggle").is(":checked"),
      "biotin",
      "Biotine",
      "biotin",
      frContainer
    );
    optionalVitaminTogglesRebuild(
      $("#pantothenicacidtoggle").is(":checked"),
      "pantothenic",
      "Pantothénate",
      "pantothenic_acid",
      frContainer
    );
    optionalVitaminTogglesRebuild(
      $("#phosphorustoggle").is(":checked"),
      "phosphorus",
      "Phosphore",
      "phosphorus",
      frContainer
    );
    optionalVitaminTogglesRebuild(
      $("#iodinetoggle").is(":checked"),
      "iodine",
      "Iode",
      "iodine",
      frContainer
    );
    optionalVitaminTogglesRebuild(
      $("#magnesiumtoggle").is(":checked"),
      "magnesium",
      "Magnésium",
      "magnesium",
      frContainer
    );
    optionalVitaminTogglesRebuild(
      $("#zinctoggle").is(":checked"),
      "zinc",
      "Zinc",
      "zinc",
      frContainer
    );
    optionalVitaminTogglesRebuild(
      $("#seleniumtoggle").is(":checked"),
      "selenium",
      "Sélénium",
      "selenium",
      frContainer
    );
    optionalVitaminTogglesRebuild(
      $("#coppertoggle").is(":checked"),
      "copper",
      "Cuivre",
      "copper",
      frContainer
    );
    optionalVitaminTogglesRebuild(
      $("#manganesetoggle").is(":checked"),
      "manganese",
      "Manganèse",
      "manganese",
      frContainer
    );
    optionalVitaminTogglesRebuild(
      $("#chromiumtoggle").is(":checked"),
      "chromium",
      "Chrome",
      "chromium",
      frContainer
    );
    optionalVitaminTogglesRebuild(
      $("#molybdenumtoggle").is(":checked"),
      "molybdenum",
      "Molybdène",
      "molybdenum",
      frContainer
    );
    optionalVitaminTogglesRebuild(
      $("#chloridetoggle").is(":checked"),
      "chloride",
      "Chlorure",
      "chloride",
      frContainer
    );
    optionalVitaminTogglesRebuild(
      $("#cholinetoggle").is(":checked"),
      "choline",
      "Choline",
      "choline",
      frContainer
    );

    $(".endofvitaminsnewlinearcanada").each(function () {
      const last_vitamin = $(this).prev("div:visible").children().last();
      if (last_vitamin.length > 0) {
        last_vitamin.html(last_vitamin.html().split(",")[0]);
      } else {
        // need different technique if no vitamins (e.g. simplified format)
        const last_nutrient = $(this).parent().prevAll("div:visible").first().children().last();
        if (last_nutrient.length > 0) {
          last_nutrient.html(last_nutrient.html().split(",")[0]);
        }
      }
    });
  } else {
    /* legacy_fda */
    optionalVitaminTogglesRebuild(
      $("#vitaminDtoggle").is(":checked"),
      "vitaminD",
      "Vitamin D",
      "vitamin_d"
    );
    optionalVitaminTogglesRebuild(
      $("#vitaminEtoggle").is(":checked"),
      "vitaminE",
      "Vitamin E",
      "vitamin_e"
    );
    isAdult() &&
      optionalVitaminTogglesRebuild(
        $("#vitaminKtoggle").is(":checked"),
        "vitaminK",
        "Vitamin K",
        "vitamin_k"
      );
    optionalVitaminTogglesRebuild(
      $("#thiamintoggle").is(":checked"),
      "thiamin",
      "Thiamin",
      "thiamin"
    );
    optionalVitaminTogglesRebuild(
      $("#riboflavintoggle").is(":checked"),
      "riboflavin",
      "Riboflavin",
      "riboflavin"
    );
    optionalVitaminTogglesRebuild($("#niacintoggle").is(":checked"), "niacin", "Niacin", "niacin");
    optionalVitaminTogglesRebuild(
      $("#vitaminB6toggle").is(":checked"),
      "vitaminB6",
      "Vitamin B6",
      "vitamin_b6"
    );
    optionalVitaminTogglesRebuild($("#folatetoggle").is(":checked"), "folate", "Folate", "folate");
    optionalVitaminTogglesRebuild(
      $("#vitaminB12toggle").is(":checked"),
      "vitaminB12",
      "Vitamin B12",
      "vitamin_b12"
    );
    optionalVitaminTogglesRebuild($("#biotintoggle").is(":checked"), "biotin", "Biotin", "biotin");
    optionalVitaminTogglesRebuild(
      $("#pantothenicacidtoggle").is(":checked"),
      "pantothenic",
      "Pantothenic Acid",
      "pantothenic_acid"
    );
    optionalVitaminTogglesRebuild(
      $("#phosphorustoggle").is(":checked"),
      "phosphorus",
      "Phosphorus",
      "phosphorus"
    );
    optionalVitaminTogglesRebuild($("#iodinetoggle").is(":checked"), "iodine", "Iodine", "iodine");
    optionalVitaminTogglesRebuild(
      $("#magnesiumtoggle").is(":checked"),
      "magnesium",
      "Magnesium",
      "magnesium"
    );
    optionalVitaminTogglesRebuild($("#zinctoggle").is(":checked"), "zinc", "Zinc", "zinc");
    isAdult() &&
      optionalVitaminTogglesRebuild(
        $("#seleniumtoggle").is(":checked"),
        "selenium",
        "Selenium",
        "selenium"
      );
    optionalVitaminTogglesRebuild($("#coppertoggle").is(":checked"), "copper", "Copper", "copper");
    isAdult() &&
      optionalVitaminTogglesRebuild(
        $("#manganesetoggle").is(":checked"),
        "manganese",
        "Manganese",
        "manganese"
      );
    optionalVitaminTogglesRebuild(
      $("#chromiumtoggle").is(":checked"),
      "chromium",
      "Chromium",
      "chromium"
    );
    optionalVitaminTogglesRebuild(
      $("#molybdenumtoggle").is(":checked"),
      "molybdenum",
      "Molybdenum",
      "molybdenum"
    );
    optionalVitaminTogglesRebuild(
      $("#chloridetoggle").is(":checked"),
      "chloride",
      "Chloride",
      "chloride"
    );
  }

  showLanguages();
  triggerSliders();
}

export const getTotalVitamins = () => totalvitamins;

export function requiredNutrientsForFormat() {
  // rebuild these no matter what
  if (isFDA()) {
    return ["vitamin_d", "calcium", "iron", "potassium"];
  } else if (isCanadian()) {
    return ["potassium", "calcium", "iron"];
  } else if (isFormat("legacy_fda/infant/vertical") || isFormat("legacy_fda/child/vertical")) {
    return ["protein", "vitamin_a", "vitamin_c", "calcium", "iron"];
  } else {
    return ["vitamin_a", "vitamin_c", "calcium", "iron"];
  }
}
